<template>
  <div class="my-tr2-box"
       :class="{'my-tr2-box-body':trType == 'body','my-tr2-box-title':trType == 'title'}"
  >
    <slot></slot>
  </div>
</template>
<script>
// <Tr1></Tr1> color:#666666; color66 color33
export default {
  name: 'Tr2',
  props: {
    trType: {
      type: String,
      default: 'body' // title
    }
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

.my-tr2-box{
  box-sizing:border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  width: 100%;
  min-height: 54px;
  border:1px solid rgba(228, 231, 237, 1);
  border-bottom:none;

  &:last-child{
    border-bottom:1px solid rgba(228, 231, 237, 1);
  }
}

.my-tr2-box-title{
  color:#333;
  background:rgba(250,250,250,1);
  font-weight:bold;
}

.my-tr2-box-body{
  color:#666;
  background:rgba(255,255,255,1);
  font-weight:400;
  &:hover{
    background:rgba(245,247,250,1);
  }
}
</style>
